import { Layout, Typography } from 'antd'
import { Outlet} from 'react-router-dom'
import MenuCenter from "./Menu"
import Header from './Header'

const { Sider, Content } = Layout
const { Text } = Typography

export default function RootLayout() {
  return (
    <Layout style={{ height: '100vh', background: 'var(--bg-root)' }}>
      <Sider
        width={52}
        theme="dark"
        style={{ borderRight: '1px solid var(--border)', background: 'var(--bg-sidebar)',color: '#94a3b8' }}
      >
        <div style={{ height: '54px', textAlign: 'center', lineHeight: '54px', borderBottom: `1px solid var(--border)}` }}>
          <Text strong style={{ color: '#1677ff', fontSize: 16 }}>
            🦔 
          </Text>
        </div>
        <MenuCenter/>
      </Sider>
      <Content style={{ overflow: 'hidden', height: '100%', background: 'var(--bg-root)',color: '#94a3b8' }}>
        <Header />
        <Outlet />
      </Content>
    </Layout>
  )
}
